module.exports = __webpack_public_path__ + "img/home_04.85637fad.png";